import React, { useState, useEffect, useCallback, useContext, useReducer } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { firebaseAuth } from "../../../providers/AuthProvider";
// import firebase from "firebase/compat/app";
import { db } from "../../../firebase";
import "firebase/functions";
import { DeleteIcon, InfoIcon, StatesList } from "../../../Constants";
import "../../../assets/css/groups.css";
// import moment from "moment";
import { toast } from "react-toastify";
import "../../../assets/css/event.css";
import DOMPurify from "dompurify";
import firebase from "firebase/compat/app";
import moment from "moment-timezone";
import { EventRecapDataContext } from "../EventRecapDataContext";
import ImageDropper from "./ImageDropper";
import VisualEditorModal from "./VisualEditorModal";
import { ArrowDownIcon, ArrowUpIcon, TrashIcon } from "@heroicons/react/24/outline";
import {
  DismissibleTag,
  IconButton,
  SwitchField,
  manageSectionTitleCls,
} from "../ManageUi";
import { getModelInterestLabel } from "../../../utils/modelInterest";
import { useModelInterestCatalog } from "../../../hooks/useModelInterestCatalog";


// import { writeJSON } from "fs-extra";

const getRegistrationStatusLabel = (registration) => {
  if (!registration?.status) return "XXX";
  if (registration.status === "Registered" && registration.isConfirmed) return "Confirmed";
  if (registration.status === "Cancelled" && registration.isNoShow) return "No Show-Cancelled";
  if (registration.status === "Cancelled" && registration.isConfirmed) return "Self-Cancelled";

  return registration.status;
};

const registrationMatchesStatusFilter = (registration, status) => {
  if (!status) return true;
  if (status === "Not Confirmed") {
    return registration.status === "Registered" && !registration.isConfirmed;
  }
  if (status === "Confirmed") {
    return registration.status === "Registered" && registration.isConfirmed;
  }
  if (status === "No Show-Cancelled") {
    return registration.status === "Cancelled" && !!registration.isNoShow;
  }
  if (status === "Self-Cancelled") {
    return registration.status === "Cancelled" && registration.isConfirmed && !registration.isNoShow;
  }

  return registration.status === status;
};

const EventRecap = () => {
  // console.log("Loading event recap.");
  const { user } = useContext(firebaseAuth);
  const modelInterestCatalog = useModelInterestCatalog();
  const reducer = (state, payload) => ({ ...state, ...payload });
  const [help, setHelp] = useState({});
  const [floatingSave, setFloatingSave] = useState(false);
  const [, setEndDateChange] = useState(false);
  const [simpleViewAttendees, setSimpleViewAttendees] = useState(false);
  const defaultFilter = JSON.parse(localStorage.getItem("regFilters"));

  const [regFilters] = useState(defaultFilter ? defaultFilter : {
    search: "",
    status: "",
    paymentStatus: "",
    waiver: "",
    guestWaiver: "",
    leadSent: "",
    pageIndex: 0,
  });
  const [, setSettings] = useState({
    mailboxes: [],
    waiverDefaultCopy: [],
    optInDefaultCopy: [],
  });
  const [registrationData, setRegistrationData] = useReducer(reducer, {
    registrations: [],
    isFetching: true,
    message: null,
  });
  const [eventRecapData, setEventRecapData] = useState(null);
  const { setCurrentEventRecapData } = useContext(EventRecapDataContext);
  useState(false);
  const [dealers, setDealers] = useState([]);
  const [showModules, setShowModules] = useState([]);
  const [, setDealerOptions] = useState([]);
  const [, setModels] = useState([]);
  const dealerSelectRef = React.createRef();
  const userListRef = React.createRef();
  const [editCopy, setEditCopy] = useState(null)
  const [, setUserList] = useState([]);
  // const [passcodeUserRefs, setPasscodeUserRefs] = useState([]);
  const defaultSort = JSON.parse(localStorage.getItem("sortOrder"));
  const [sortOrder] = useState(defaultSort ? defaultSort : "");
  const [dayList, setDayList] = useState([]);
  const [sessionList, setSessionList] = useState([]);
  const [, setSessionData] = useState(null);
  const history = useNavigate();
  const [importReg, setImportReg] = useState(false);
  const { id } = useParams();
  const loadInit = async () => {
    let storageEventRecapData = sessionStorage.getItem('eventRecapData');
    // console.log(storageEventRecapData);
    if (storageEventRecapData && (storageEventRecapData === '' || storageEventRecapData === 'undefined')) {
      history("/manage");
      return;
    }
    let tmpEventRecapData = null; //JSON.parse(storageEventRecapData);
    // console.log(tmpEventRecapData);
    if (tmpEventRecapData && tmpEventRecapData !== '')
      setEventRecapData(tmpEventRecapData);
    // let tmpEventRecapData = currentEventRecapData
    if (!tmpEventRecapData || tmpEventRecapData?.id !== id) {
      if (id) {
        let tmpUpdateEventRecapData = await db.collection("event-recaps").doc(id).get();
        tmpEventRecapData = tmpUpdateEventRecapData.data();
      } else {
        let tmpEventId = await db.collection("event-recaps").doc().id;
        const newEventRecap = {
          id: tmpEventId, name: 'New Event Recap', email: 'info', status: 'Active', sortOrder: 0, usersAllowed: [{ name: user.email }],
          dataFields: {
            experience: { visible: true, required: false }, firstName: { visible: true, required: true }, title: { visible: false, required: false },
            address1: { visible: false, required: false }, city: { required: false, visible: false }, dealer: { visible: false }, email: { visible: true, required: true }, lastName: { visible: true, required: true },
            modelInterest: { visible: false }, phone: { visible: false }, postal: { required: true, visible: true }, purchaseTimeFrame: { visible: true }, state: { required: false, visible: false }
          }
        }
        tmpEventRecapData = newEventRecap;
      }
    }
    if (tmpEventRecapData) {
      setEventRecapData(tmpEventRecapData);
      setCurrentEventRecapData(tmpEventRecapData);
      sessionStorage.setItem('eventRecapData', JSON.stringify(tmpEventRecapData));
    } else {
      toast.error("Select to edit or view registrations for an event before continuing..");
      history("/manage");
      return;
    }
    let regInfo = await firebase.functions().httpsCallable("appV2/regCount");
    let result = await regInfo({ id: eventRecapData?.id });
    if (!result.data.error && tmpEventRecapData)
      tmpEventRecapData.regCount = result.data;

    if (!tmpEventRecapData.dataFields) tmpEventRecapData.dataFields = [];
    if (tmpEventRecapData.createdAt && tmpEventRecapData.createdAt.seconds) {
      tmpEventRecapData.createdAt = new Date(tmpEventRecapData.createdAt.seconds * 1000 + tmpEventRecapData.createdAt.nanoseconds / 1000000)
    } else if (tmpEventRecapData.createdAt && tmpEventRecapData.createdAt._seconds) {
      tmpEventRecapData.createdAt = new Date(tmpEventRecapData.createdAt._seconds * 1000 + tmpEventRecapData.createdAt._nanoseconds / 1000000)
    } else if (tmpEventRecapData.createdAt) {
      tmpEventRecapData.createdAt = new Date(tmpEventRecapData.createdAt)
    }
    if (tmpEventRecapData.updatedAt && tmpEventRecapData.updatedAt.seconds)
      tmpEventRecapData.updatedAt = new Date(tmpEventRecapData.updatedAt.seconds * 1000 + tmpEventRecapData.updatedAt.nanoseconds / 1000000)
    else if (tmpEventRecapData.updatedAt && tmpEventRecapData.updatedAt._seconds)
      tmpEventRecapData.updatedAt = new Date(tmpEventRecapData.updatedAt._seconds * 1000 + tmpEventRecapData.updatedAt._nanoseconds / 1000000)
    else if (tmpEventRecapData.updatedAt)
      tmpEventRecapData.updatedAt = new Date(tmpEventRecapData.updatedAt);
    // console.log(tmpEventRecapData.additionalFields);
    setEventRecapData({ ...tmpEventRecapData });
    console.log("Temp on init:");
    console.log(tmpEventRecapData);
    // console.log(tmpEventRecapData.createdAt);
  }
  useEffect(() => {
    // if (!eventRecapData || !eventRecapData?.id) {
    //   toast.warning("Select to edit or view registrations for an event before continuing..");
    //   return <Redirect to="/manage" />;
    // }
    // let tmpShowModules = localStorage.getItem('showModules');
    // if (tmpShowModules) {
    //   setShowModules(JSON.parse(tmpShowModules));
    // } else {
    //   setShowModules({details:true,design:false,notifications:true,configuration:true,passcodes:false,capacities:false,leads:false,fields:false});
    // }
    loadInit();

    DOMPurify.setConfig({ ADD_ATTR: ['target'] });
    db.collection("settings")
      .doc("current")
      .get()
      .then((docRef) => {
        setSettings(docRef.data());
      });
    db.collection("dealers")
      .get()
      .then((qs) => {
        if (qs.docs.length > 0) {
          let tmpItems = [];
          qs.docs.forEach((item, index) => {
            let tmpItem = item.data();
            tmpItem.id = item.id;
            tmpItems.push(tmpItem);
          });
          setDealers(tmpItems);
          let options = [{ value: "", label: "No preference" }];
          let dealerOptions = [];
          tmpItems?.forEach((dealer, index) => {
            dealerOptions.push({ value: dealer.code, label: dealer.name + " (" + dealer.code + ")" });
          });
          dealerOptions.sort((a, b) => (a.label > b.label) ? 1 : ((b.label > a.label) ? -1 : 0))
          setDealerOptions(options.concat(dealerOptions));
        }
      });
    db.collection("models")
      .get()
      .then((qs) => {
        if (qs.docs.length > 0) {
          let tmpItems = [];
          qs.docs.forEach((item, index) => {
            let tmpItem = item.data();
            tmpItem.id = item.id;
            tmpItems.push(tmpItem);
          });
          setModels(tmpItems);
        }
      });
    if (user.role <= 1) {
      setTimeout(() => {
        var getUserList = firebase.functions().httpsCallable("appV2/userList");
        getUserList().then(async function (result) {
          setUserList(result.data);
        });
      }, 20);
    }

    window.addEventListener("scroll", handleScroll, { passive: true });
    // eslint-disable-next-line react-hooks/exhaustive-deps -- intent: run-once init on mount; loadInit/user.role lookups should not re-fire mid-session
  }, []);
  const removeCloudinary = (pubId, key, disableNotifications) => {
    var remove = firebase.functions().httpsCallable("appV2/removeCloudinary");
    remove(pubId)
      .then((result) => {
        if (result?.data.message) {
          toast.warning(result?.data.message);
          return "";
        } else {
          if (!disableNotifications) toast.success("Image removal successful.");
          let tmpInputs = eventRecapData;
          if (key) {
            tmpInputs[key] = "";
            let img = document.getElementById(key);
            // remove element?
            setEventRecapData(tmpInputs);
            db.collection("events").doc(tmpInputs.id).set(tmpInputs);
            setEventRecapData(tmpInputs);
            setCurrentEventRecapData(tmpInputs);
            sessionStorage.setItem('eventData', JSON.stringify(tmpInputs));
          }
        }
      })
      .catch((error) => {
        console.log(error);
        if (!disableNotifications) toast.error(error.message);
      });
  }
  const handleGalleryImageRead = async (file, i, action, imageMeta = {}, eventRecapData) => {
    // const file = event.target.files[0];
    if (!file) return;

    const timestamp = Date.now();

    // Convert the file to a base64 string
    const base64 = await convertBase64(file);


    let updatedFiles = eventRecapData?.galleryImages || [];

    const newFile = {
      ...file,
      preview: '', // Add the uploaded URL
      imageMeta: imageMeta || {}, // Add metadata
      timestamp, // Add a unique timestamp
    };

    if (action === "replace") {
      console.log("REPLACE action triggered");
      // Replace the file at the specified index
      const index = updatedFiles.findIndex((img) => img.timestamp === file.timestamp);
      if (index !== -1) {
        updatedFiles[index] = newFile;
      }
    } else if (action === "append") {
      console.log("APPEND action triggered");
      updatedFiles[i] = newFile; // Append the new file object 
    }

    // let updatedEventRecapData = { ...eventRecapData, galleryImages: updatedFiles };
    console.log(eventRecapData);

    // Upload the image to Cloudinary (or your cloud service)
    await uploadCloudinary(
      base64,
      `${eventRecapData?.id}_galleryImage_${i}`, // Unique identifier for the image
      `/pcna/ezentrum/${eventRecapData?.id}/`, // Folder path
      `galleryImage${i}`, // Public ID
      null,
      'galleryImages',
      i,
      'preview',
      eventRecapData
    );

    return { ...eventRecapData, galleryImages: updatedFiles };

    // uploadCloudinary(base64, eventRecapData?.id + "_galleryImage_" + i, "/pcna/ezentrum/" + eventRecapData?.id + "/", "galleryImage" + i, null, 'galleryImages', i);
  };
  const handleScroll = (e) => {
    let target = document.body;
    // console.log(target);
    let currentScrollY = window.scrollY;
    if (currentScrollY > 52 && currentScrollY < (target.clientHeight - (window.innerHeight + 100))) {
      // console.log("Setting floating save to True.");
      setFloatingSave(true);
    } else if (currentScrollY >= (target.clientHeight - (window.innerHeight + 100))) {
      // console.log("Setting floating save to False.");
      setFloatingSave(false);

    }
  }
  const handleSubmit = async (e) => {
    if (e)
      e.preventDefault();
    // if (user.role > 2) {
    //   alert('Only admins and managers can save / update an event.');
    //   return;
    // }
    let tmpEventRecapData = { ...eventRecapData };

    if (tmpEventRecapData?.id && tmpEventRecapData?.id !== 1) {
      // console.log(tmpEventRecapData.updatedAt);
      if (tmpEventRecapData.updatedAt) {
        var checkEventRecapData = await db.collection("event-recaps").doc(tmpEventRecapData?.id).get();
        let tmpCheckUpdatedAt = checkEventRecapData.data()?.updatedAt;

        if (tmpEventRecapData.updatedAt && tmpCheckUpdatedAt?.seconds && tmpCheckUpdatedAt?.nanoseconds) {
          let updatedAt = new Date(tmpEventRecapData?.updatedAt);
          let checkUpdatedAt = new Date(tmpCheckUpdatedAt.seconds * 1000 + tmpCheckUpdatedAt.nanoseconds / 1000000);
          console.log(checkUpdatedAt);
          console.log(tmpEventRecapData?.updatedAt);

          if (checkUpdatedAt.getTime() > updatedAt.getTime()) {
            let continueSave = window.confirm("This event has been saved by someone else since it was loaded.  Do you want to overwrite any changes made with this data?  If not, press cancel, and reload your event from the dashboard.");
            if (continueSave)
              console.log('User overwrite previous save.');
            else
              return;
          }
        }
      }
      if (!tmpEventRecapData.createdAt || isNaN(tmpEventRecapData.createdAt)) {
        tmpEventRecapData.createdAt = firebase.firestore.FieldValue.serverTimestamp();
      }
      tmpEventRecapData.updatedAt = firebase.firestore.FieldValue.serverTimestamp();
      console.log(tmpEventRecapData);
      db.collection("event-recaps").doc(tmpEventRecapData?.id).set(tmpEventRecapData)
        .then(() => {
          db.collection("event-recaps").doc(tmpEventRecapData?.id).get()
            .then(doc => {
              if (!doc.exists) {
                console.log("No such document!"); //Error
              } else {
                let evtData = doc.data();
                if (evtData.createdAt)
                  evtData.createdAt = new Date(evtData.createdAt.seconds * 1000 + evtData.createdAt.nanoseconds / 1000000)
                if (evtData.updatedAt)
                  evtData.updatedAt = new Date(evtData.updatedAt.seconds * 1000 + evtData.updatedAt.nanoseconds / 1000000)

                setEventRecapData(evtData);
                setCurrentEventRecapData(evtData);
                sessionStorage.setItem('eventRecapData', JSON.stringify(evtData));
                console.log()
                toast.success("Event saved successfully.");
              }
            })
            .catch(function (error) {
              console.error("Error adding document: ", error);
            })
        })
        .catch(function (error) {
          console.error("Error adding document: ", error);
        });
    } else {
      tmpEventRecapData.createdAt = firebase.firestore.FieldValue.serverTimestamp();
      tmpEventRecapData.updatedAt = firebase.firestore.FieldValue.serverTimestamp();
      db.collection("event-recaps")
        .add(eventRecapData)
        .then((docRef) => {
          setEventRecapData({ ...tmpEventRecapData, id: docRef.id });
          let tmpEvent = tmpEventRecapData;
          tmpEvent.id = docRef.id;
          setEventRecapData(tmpEvent);
          setCurrentEventRecapData(tmpEvent);
          sessionStorage.setItem('eventRecapData', JSON.stringify(tmpEvent));
          toast.success("Event saved successfully.");
        })
        .catch(function (error) {
          console.error("Error adding document: ", error);
        });
    }
  };
  const handleChange = (e) => {
    if (e.target.name === "endDate") {
      setEndDateChange(true);
    }
    if (e.target.name === "groupId") {
      setEventRecapData({
        ...eventRecapData,
        [e.target.name]: e.target.value,
        groupName: e.target.options[e.target.selectedIndex].text
      });
    } else {
      setEventRecapData({
        ...eventRecapData,
        [e.target.name]: e.target.value,
      });
      console.log(eventRecapData);
    }
  };
  const [fieldList] = useState({ company: true, title: true, firstName: true, lastName: true, email: true, phone: true, address1: true, address2: true, city: true, state: true, postal: true, createdDate: false, updatedDate: false, status: false, paymentStatus: false, guest: false, waiver: false, guestWaiver: false, dealer_optin: false, dealer: true, experience: false, modelInterest: false, purchaseTimeFrame: false, disableLead: false, leadSent: false, passcode: false, itemInfo: eventRecapData?.allowCapacity && eventRecapData?.capacityType === "session" && eventRecapData?.sessionItems.length > 1, sessionInfo: eventRecapData?.allowCapacity && eventRecapData?.capacityType === "session", notes: false })
  const uploadCloudinary = async (file, pubId, folder, key, transformation, list, i, field, data) => {
    //uploadCloudinary(base64, eventRecapData?.id + "_" + x + "_" + i, "/pcna/ezentrum/" + eventRecapData?.id + "/", x + i, null, true, i);
    let uploadData = { file: file, public_id: pubId, folder: folder, transformation: transformation };
    var upload = firebase.functions().httpsCallable("appV2/uploadCloudinary");

    await upload(uploadData)
      .then((result) => {
        if (result?.data.message) {
          toast.warning(result?.data.message);
          return "";
        } else {
          let tmpInputs = data;
          let u = result.data.url;
          // console.log(u);
          // console.log(list);
          // console.log(key);
          // console.log('======')
          //.split("/");
          // u.splice(6,1);
          // u = u.join("/");
          if (!list)
            tmpInputs[key] = u;
          console.log(key);



          // let img = document.getElementById(key);
          // console.log(img);
          // img.src = img.src + "?v=" + Date.now(); // trick browser into reload
          if (!list) {
            setEventRecapData({ ...tmpInputs });
            db.collection("event-recaps").doc(tmpInputs.id).set(tmpInputs);
            setEventRecapData(tmpInputs);
            setCurrentEventRecapData(tmpInputs);
            sessionStorage.setItem('eventRecapData', JSON.stringify(tmpInputs));
          } else {
            let tmpImages = data[list];
            if (!field) {
              tmpImages[i] = u;
              // setEventRecapData({ ...data, tmpImages: tmpImages });
            } else {
              console.log("Setting field " + field + " to " + u);
              console.log(data);
              console.log(list);
              console.log(tmpImages);
              // console.log(tmpImages);
              tmpImages[i][field] = u;
            }
            setEventRecapData({ ...data, tmpImages: tmpImages });
          }
        }
      })
      .catch((error) => {
        console.log(error);
        toast.error(error.message);
      });
  }
  const handleChangeItem = useCallback((idkey, value) => {
    setEventRecapData(value);
  }, []);
  const processsFile = (file) => {
    return new Promise((resolve, reject) => {
      const fileReader = new FileReader();
      fileReader.onload = () => {
        resolve(fileReader.result);
      };
      fileReader.onerror = (error) => {
        reject(error);
      };
      fileReader.readAsText(file);
    });
  };
  const fetch = (tmpEventData) => {
    // console.log("fetching...");
    if (!tmpEventData)
      tmpEventData = eventRecapData;
    let tmpItems = [];

    // console.log(tmpEventData);

    if (!tmpEventData?.id) return;

    let tmpSortOrder = sortOrder
      ? sortOrder
      : JSON.parse(localStorage.getItem("sortOrder"));
    let so = tmpSortOrder?.split("|");
    let cutoff = moment().add(-900, 'days');


    // if (tmpEventData?.endDate) {
    if (so && so.length === 2) {
      // db.collection("registrations")
      //   .where("eventId", "==", tmpEventData?.id)
      //   .orderBy(so[0], so[1])
      //   .get()
      //   .then(function (querySnapshot) {
      //     querySnapshot.forEach(function (doc) {

      tmpEventData?.registrations?.forEach((doc, index) => {
        let tmpItem = doc.data();
        tmpItem.id = doc.id;
        if (tmpItem?.sessionDate) {
          tmpItem.sessionDate = tmpItem.sessionDate.replace(",", "");
        }

        if (tmpItem.createdAt && !tmpItem.createdDate)
          try {
            if (tmpItem.createdAt.seconds) {
              // tmpItem.createdAt = tmpItem.createdAt.seconds * 1000 + tmpItem.createdAt.nanoseconds / 1000000;
              tmpItem.createdDate = moment((tmpItem.createdAt.seconds * 1000 + tmpItem.createdAt.nanoseconds / 1000000)).format(
                "MM/DD/YYYY h:mm A"
              );
            } else {
              // alert('ehllo2');
              tmpItem.createdDate = moment(tmpItem.createdAt).format(
                "MM/DD/YYYY h:mm A"
              );
            }
          } catch {
          }
        if (tmpItem.updatedAt && !tmpItem.updatedDate)
          try {
            if (tmpItem.updatedAt.seconds) {
              // tmpItem.createdAt = tmpItem.createdAt.seconds * 1000 + tmpItem.createdAt.nanoseconds / 1000000;
              tmpItem.updatedDate = moment((tmpItem.updatedAt.seconds * 1000 + tmpItem.updatedAt.nanoseconds / 1000000)).format(
                "MM/DD/YYYY h:mm A"
              );
            } else {
              tmpItem.updatedDate = moment(tmpItem.updatedAt).format(
                "MM/DD/YYYY h:mm A"
              );
            }
          } catch {
          }
        let allowPush = true;
        if (tmpEventData?.allowPasscodes && tmpEventData?.requireMultiUsePasscodes && user.role !== 1 && tmpItem.passcode) {
          allowPush = false;
          let pc = tmpEventData?.multiUsePasscodes?.find(o => o.passcode.toUpperCase() === tmpItem.passcode.toUpperCase());
          if (pc && (!pc.usersAllowed || pc.usersAllowed.length === 0 || pc.usersAllowed?.find(o => o.name === user.email))) {
            allowPush = true;
          }
        }
        if (allowPush) {
          let tmpSessionList = sessionList;
          let tmpDayList = dayList;
          let tmpSession = tmpItem.sessionId ? tmpItem.sessionDate + " " + tmpItem.sessionTime : "";
          let tmpDay = tmpItem.sessionId ? tmpItem.sessionDate : "";
          if (tmpDay.trim() !== "") {
            if (tmpDayList.indexOf(tmpDay) === -1) {
              tmpDayList.push(tmpDay);
              setDayList(tmpDayList.sort(function (a, b) {
                // Turn your strings into dates, and then subtract them
                // to get a value that is either negative, positive, or zero.
                let aDate = moment(a, "dddd MMMM Do YYYY");
                let bDate = moment(b, "dddd MMMM Do YYYY");
                let m = aDate.diff(bDate);
                return m;
              }));
            }
            if (tmpSessionList.indexOf(tmpSession) === -1) {
              tmpSessionList.push(tmpSession);
              setSessionList(tmpSessionList.sort(function (a, b) {
                // Turn your strings into dates, and then subtract them
                // to get a value that is either negative, positive, or zero.
                let aDate = moment(a, "dddd MMMM Do YYYY h:mm A");
                let bDate = moment(b, "dddd MMMM Do YYYY h:mm A");
                let m = aDate.diff(bDate);
                return m;
              }));
            }
          }
          tmpItems.push(tmpItem);
        }
      });
      setRegistrationData({
        registrations: tmpItems,
        isFetching: false,
        message: null,
        filtered: null,
        filter: true,
      });
      // localStorage.setItem('regData',JSON.stringify(tmpItems));

      // })
      // .catch(function (error) {
      //   console.log("Error getting documents: ", error);
      //   setRegistrationData({
      //     tmpItems: registrationData.registrations,
      //     isFetching: false,
      //     filtered: null,
      //     filter: true,
      //     message: null,
      //   });
      // });
    } else {
      // db.collection("registrations")
      //   .where("eventId", "==", tmpEventData?.id)
      //   .get()
      //   .then(function (querySnapshot) {
      //     console.log("checkpoint 1");

      tmpEventData?.registrations?.forEach((tmpItem, index) => {
        // querySnapshot.forEach(function (doc) {
        // let tmpItem = doc.data();
        // let tmpDealer = null;
        // if (tmpItem.passcode && tmpEventData?.allowMultiUsePasscodes && tmpEventData?.multiUsePasscodes && tmpEventData?.multiUsePasscodes.length > 0 && !tmpItem.dealer) {
        //   // console.log(tmpItem.passcode);
        //   // console.log(tmpEventData?.multiUsePasscodes);
        //   let pc = tmpEventData?.multiUsePasscodes?.find(o => o.passcode.toUpperCase() === tmpItem.passcode.toUpperCase());
        //   if (pc && pc.dealer) {
        //     console.log(pc);
        //     tmpDealer = pc.dealer;
        //     // console.log('updated deealer',tmpDealer);
        //     db.collection("registrations").doc(doc.id).update({ dealer: tmpDealer });
        //   }
        // }
        if (tmpItem?.sessionDate) {
          tmpItem.sessionDate = tmpItem.sessionDate.replace(",", "");
        }
        tmpItem.id = index;
        if (tmpItem.createdAt && !tmpItem.createdDate) {
          if (tmpItem.createdAt.seconds) {
            tmpItem.createdDate = moment((tmpItem.createdAt.seconds * 1000 + tmpItem.createdAt.nanoseconds / 1000000)).format(
              "MM/DD/YYYY h:mm A"
            );
          } else {
            tmpItem.createdDate = moment(tmpItem.createdAt).format(
              "MM/DD/YYYY h:mm A"
            );
          }
        }
        let allowPush = true;
        if (tmpEventData?.allowPasscodes && tmpEventData?.requireMultiUsePasscodes && user.role !== 1 && tmpItem.passcode) {
          allowPush = false;
          let pc = tmpEventData?.multiUsePasscodes?.find(o => o.passcode.toUpperCase() === tmpItem.passcode.toUpperCase());
          if (pc && (!pc.usersAllowed || pc.usersAllowed.length === 0 || pc.usersAllowed?.find(o => o.name === user.email))) {
            allowPush = true;
          }
        }
        if (allowPush) {
          let tmpSessionList = sessionList;
          let tmpDayList = dayList;
          let tmpSession = tmpItem.sessionId ? tmpItem.sessionDate + " " + tmpItem.sessionTime : "";
          let tmpDay = tmpItem.sessionId ? tmpItem.sessionDate : "";
          if (tmpDay.trim() !== "") {
            if (tmpDayList.indexOf(tmpDay) === -1) {
              tmpDayList.push(tmpDay);
              setDayList(tmpDayList.sort(function (a, b) {
                // Turn your strings into dates, and then subtract them
                // to get a value that is either negative, positive, or zero.
                let aDate = moment(a, "dddd MMMM Do YYYY");
                let bDate = moment(b, "dddd MMMM Do YYYY");
                let m = aDate.diff(bDate);
                return m;
              }));
            }
            if (tmpSessionList.indexOf(tmpSession) === -1) {
              tmpSessionList.push(tmpSession);
              setSessionList(tmpSessionList.sort(function (a, b) {
                // Turn your strings into dates, and then subtract them
                // to get a value that is either negative, positive, or zero.
                let aDate = moment(a, "dddd MMMM Do YYYY h:mm A");
                let bDate = moment(b, "dddd MMMM Do YYYY h:mm A");
                let m = aDate.diff(bDate);
                return m;
              }));
            }
          }
          tmpItems.push(tmpItem);
        }
      });
      if (so && so.length === 3) {
        tmpItems = tmpItems.sort(function (a, b) {
          // Turn your strings into dates, and then subtract them
          // to get a value that is either negative, positive, or zero.
          let aDate = moment(a.sessionDate + " " + a.sessionTime, "dddd MMMM Do YYYY h:mm A");
          let bDate = moment(b.sessionDate + " " + b.sessionTime, "dddd MMMM Do YYYY h:mm A");
          if (a.sessionDate && b.sessionDate) {
            if (so[2] === "asc") {
              let m = aDate.diff(bDate);
              return m;
            } else {
              let m = bDate.diff(aDate);
              return m;
            }
          } else if (a.sessionDate && !b.sessionDate) {
            return -1;
          } else {
            return 1;
          }
        })
      }
      setRegistrationData({
        registrations: tmpItems,
        isFetching: false,
        message: null,
        filtered: null,
        filter: true,
      });
      localStorage.setItem("regData", JSON.stringify(tmpItems));
      // })


      // .catch(function (error) {
      //   console.log("Error getting documents: ", error);
      //   setRegistrationData({
      //     tmpItems: registrationData.registrations,
      //     isFetching: false,
      //     filtered: null,
      //     filter: true,
      //     message: null,
      //   });
      // });
    }
    // } else if (!tmpEventData?.endDate) {
    //   setRegistrationData({
    //     registrations: null,
    //     isFetching: false,
    //     message: "Event must have an end date to show registrations to comply with PCNA data security requirements.",
    //     filtered: null,
    //     filter: false,
    //   });
    // } else {
    //   setRegistrationData({
    //     registrations: null,
    //     isFetching: false,
    //     message: "Data has been removed 90 days after the event to comply with PCNA data security requirements.",
    //     filtered: null,
    //     filter: false,
    //   });
    // }
  };
  const handleFileRead = async (event) => {
    let valid = 0;
    let invalid = 0;
    const file = event.target.files[0];
    if (file.name.indexOf(".csv") === -1) {
      alert(
        "File must be a valid csv file, download the provided template if needed."
      );
      return;
    }
    const csv = await processsFile(file);

    var allTextLines = csv.split(/\r\n|\n/);

    var lines = [];
    for (var i = 0; i < allTextLines.length; i++) {
      var data = allTextLines[i].split(",");
      var tarr = [];

      if (data.length === 12 && i > 0) {
        valid = valid + 1;
        for (var j = 0; j < data.length; j++) {
          tarr.push(data[j]);
        }
        lines.push(tarr);
      } else if (data.length === 1 && data[0] === "") {
      } else if (i > 0) {
        invalid = invalid + 1;
      }
    }

    let formattedRegistrations = [];


    lines.forEach((l, i) => {
      let r = {};
      r.id = i;
      r.createdAt = Date.now();
      r.status = "Registered";
      r.eventId = eventRecapData?.id;
      r.company = l[0];
      r.title = l[1];
      r.firstName = l[2];
      r.lastName = l[3];
      r.email = l[4];
      r.phone = l[5];
      r.address1 = l[6];
      r.address2 = l[7];
      r.city = l[8];
      r.state = l[9];
      r.postal = l[10];
      r.dealer = l[11];
      // r.packages = l[12];
      // db.collection("registrations")
      //   .doc(r.id)
      //   .set(r);

      formattedRegistrations.push(r);
    });

    await setEventRecapData({ ...eventRecapData, registrations: formattedRegistrations });

    toast.success(
      `Import complete: ${valid ? valid : 0} of ${valid + invalid} records.`
    );

    fetch({ ...eventRecapData, registrations: formattedRegistrations });
    // setImportReg(false);
  };
  const filter = () => {
    let registrations = registrationData.registrations;
    if (!registrations || registrations.length === 0) {
      // let tempReg = JSON.parse(localStorage.getItem('regData'));
      // if(!tempReg || tempReg.length === 0) {
      //   tempReg = [];
      // }
      // registrations = tempReg;
      fetch();
      return;
    }
    let filteredReg = [];
    registrations.forEach((reg, i) => {
      reg.idx = i;

      if (regFilters && !regFilters.status && !regFilters.paymentStatus && !regFilters.search && !regFilters.waiver && !regFilters.guestWaiver && !regFilters.session && !regFilters.passcode && !regFilters.leadSent && !regFilters.item && !regFilters.day) {
        filteredReg.push(reg);
      } else {
        let searchCheck = !regFilters?.search;
        let waiverCheck = !regFilters?.waiver;
        let guestWaiverCheck = !regFilters?.guestWaiver;
        let statusCheck = !regFilters?.status;
        let sessionCheck = !regFilters?.session;
        let dayCheck = !regFilters?.day;
        let itemCheck = !regFilters?.item;
        let passcodeCheck = !regFilters?.passcode;
        let leadSentCheck = regFilters?.leadSent ? false : true;
        let paymentStatusCheck = !regFilters?.paymentStatus;
        if (!searchCheck) {
          if (
            reg.company
              ?.toUpperCase()
              .indexOf(regFilters?.search?.toUpperCase()) > -1 ||
            reg.firstName
              ?.toUpperCase()
              .indexOf(regFilters?.search?.toUpperCase()) > -1 ||
            reg.lastName
              ?.toUpperCase()
              .indexOf(regFilters?.search?.toUpperCase()) > -1 ||
            reg.email?.toUpperCase().indexOf(regFilters?.search?.toUpperCase()) >
            -1
          ) {
            searchCheck = true;
          }
        }
        if (!statusCheck) {
          if (registrationMatchesStatusFilter(reg, regFilters?.status)) {
            statusCheck = true;
          }
        }
        if (!sessionCheck) {
          if (reg.sessionDate + " " + reg.sessionTime === regFilters?.session) {
            sessionCheck = true;
          }
        }
        if (!passcodeCheck) {
          if (reg?.passcode?.toUpperCase() === regFilters?.passcode.toUpperCase()) {
            passcodeCheck = true;
          }
        }
        if (!leadSentCheck) {

          if (reg.leadSent && regFilters?.leadSent === "Yes") {
            leadSentCheck = true;
            i++;
          }

          if (!reg.leadSent && regFilters?.leadSent === "No") {
            leadSentCheck = true;
          }
        }

        if (!dayCheck) {
          if (reg.sessionDate === regFilters?.day) {
            dayCheck = true;
          }
        }
        if (!itemCheck) {
          if (reg.sessionItemId === regFilters?.item) {
            itemCheck = true;
          }
        }
        if (!paymentStatusCheck) {
          if (reg.adyenPaymentStatus === regFilters?.paymentStatus) {
            paymentStatusCheck = true;
          }
        }
        if (!waiverCheck) {
          if (
            (regFilters.waiver === "Yes" && reg.hasWaiver) ||
            (regFilters.waiver === "No" && !reg.hasWaiver)
          ) {
            waiverCheck = true;
          }
        }
        if (!guestWaiverCheck) {
          if (
            (regFilters.guestWaiver === "Yes" && reg.hasGuestWaiver) ||
            (regFilters.guestWaiver === "No" && !reg.hasGuestWaiver && (reg.guestFirstName || reg.guestLastName))
          ) {
            guestWaiverCheck = true;
          }
        }
        if (searchCheck && statusCheck && paymentStatusCheck && waiverCheck && guestWaiverCheck && sessionCheck && passcodeCheck && leadSentCheck && dayCheck && itemCheck) filteredReg.push(reg);
      }

    });
    setRegistrationData({ ...registrationData, filtered: filteredReg, filter: false });
  };
  useEffect(() => {
    if (!registrationData.isFetching && registrationData.filter) {
      filter();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps -- intent: re-run only when registrationData reference changes; filter() is component-scope
  }, [registrationData]);
  useEffect(() => {
    fetch();
    // eslint-disable-next-line react-hooks/exhaustive-deps -- intent: refetch only when source registrations array reference changes; fetch is component-scope
  }, [eventRecapData?.registrations]);
  const convertBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const fileReader = new FileReader();
      fileReader.readAsDataURL(file); // Read the original file object
      fileReader.onload = () => {
        resolve(fileReader.result);
      };
      fileReader.onerror = (error) => {
        reject(error);
      };
    });
  };
  useEffect(() => {
    if (!user.isAuthenticated) {
      history("/manage/sign-in");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps -- intent: re-check auth only on user change; history (react-router navigate) is stable across renders
  }, [user]);
  useEffect(() => {
    try {
      setSessionData(eventRecapData?.sessions ? eventRecapData?.sessions : []);
    } catch (e) {
      console.log('error', e);
    }
  }, [eventRecapData?.sessions]);
  const updateShowModules = (module, value) => {
    let tmpShowModules = { ...showModules };
    tmpShowModules[module] = value;
    setShowModules(tmpShowModules);
    localStorage.setItem('showModules', JSON.stringify(tmpShowModules));
  }
  const alertCheck = (x, r) => {
    let alert = false;
    switch (x) {
      case "IncompleteWaiver":
        if (r.status !== "Waitlist" && r.status !== "Cancelled" && !r.hasWaiver)
          alert = true;
        break;
      case "IncompleteGuestWaiver":
        if (r.status !== "Waitlist" && r.status !== "Cancelled" && !r.hasGuestWaiver)
          alert = true;
        break;
      case "IncompletePayment":
        if (r.status !== "Waitlist" && r.status !== "Cancelled" && (r.adyenPaymentStatus === "Pending" || r.adyenPaymentStatus === "" || !r.adyenPaymentStatus))
          alert = true;
        break;
      case "IsGuest":
        if (r.isGuest)
          alert = true;
        break;
      case "Pending":
        if (r.status === "Pending")
          alert = true;
        break;
      case "NotCheckedIn":
        if (r.status === "Registered" || r.status === "Pending")
          alert = true;
        break;
      case "CheckedIn":
        if (r.status === "Checked-In")
          alert = true;
        break;
      case "Completed":
        if (r.status === "Completed")
          alert = true;
        break;
      case "Waitlist":
        if (r.status === "Waitlist")
          alert = true;
        break;
      default:
        alert = false;
    }
    return alert;
  }
  const alertRules = (r) => {
    if (alertCheck(eventRecapData?.redAlert, r)) {
      return "red-alert ";
    } else if (alertCheck(eventRecapData?.yellowAlert, r)) {
      return "yellow-alert ";
    } else if (alertCheck(eventRecapData?.orangeAlert, r)) {
      return "orange-alert ";
    } else if (alertCheck(eventRecapData?.purpleAlert, r)) {
      return "purple-alert ";
    } else if (alertCheck(eventRecapData?.blueAlert, r)) {
      return "blue-alert ";
    } else if (alertCheck(eventRecapData?.greenAlert, r)) {
      return "green-alert ";
    }
    return "";
  }
  const getPasscodeDescription = (passcode) => {
    let desc = eventRecapData?.multiUsePasscodes?.find(o => o.passcode?.toUpperCase() === passcode?.toUpperCase())?.description
    if (desc) return " - " + desc; else return "";
  }
  const getExperience = (value) => {
    switch (value) {
      case "A1": return "I’ve never driven a Porsche, and not familiar with the Brand";
      case "A2": return "I’ve never driven a Porsche, but I’m familiar with the Brand";
      case "A3": return "I’ve driven a Porsche, but never owned a Porsche";
      case "A4": return "I’ve owned a Porsche, but do not currently own";
      case "A5": return "I currently own a Porsche";
      default: return value;
    }
  };
  const getModelInterest = (value) =>
    getModelInterestLabel(value, modelInterestCatalog);
  const getPurchaseTimeFrame = (value) => {
    switch (value) {
      case "id_ao1_timeframe": return "0 - 3 months";
      case "id_ao2_timeframe": return "3 - 6 months";
      case "id_ao3_timeframe": return "6 - 9 months";
      case "id_ao4_timeframe": return "9 - 12 months";
      case "id_ao5_timeframe": return "12 months+";
      default: return value;
    }
  }
  const addCaption = (e, index) => {
    e.preventDefault();
    // console.log(formData);
    let sanitizedInput = eventRecapData.galleryImages[index]?.captionInput?.trim().toUpperCase();
    let tmpEventRecapData = { ...eventRecapData };
    tmpEventRecapData.galleryImages[index].caption = tmpEventRecapData.galleryImages[index].caption || [];
    if (!sanitizedInput) {
      toast.error('Caption cannot be empty.', 'alert-error');
      return;
    }
    if (tmpEventRecapData.galleryImages[index].caption.includes(sanitizedInput)) {
      toast.error('Caption already exists.', 'alert-error');
      return;
    }
    // Add the caption to the file's caption array
    tmpEventRecapData.galleryImages[index].caption.push(sanitizedInput);

    tmpEventRecapData.galleryImages[index].captionInput = ''; // Clear the input field after adding the caption

    setEventRecapData(tmpEventRecapData || []);
  }
  const labelCls = "block text-sm font-medium text-zinc-700 dark:text-zinc-300";
  const inputCls = "mt-2 block w-full rounded-md bg-zinc-50 px-3 py-2 text-sm text-zinc-900 shadow-sm ring-1 ring-inset ring-zinc-300 placeholder:text-zinc-400 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-zinc-900 disabled:cursor-not-allowed disabled:opacity-60 dark:bg-zinc-800 dark:text-zinc-100 dark:ring-white/10 dark:placeholder:text-zinc-500 dark:focus:ring-white";
  const primaryBtnCls = "inline-flex items-center justify-center rounded-md bg-zinc-900 px-3 py-2 text-sm font-semibold text-zinc-50 shadow-sm hover:bg-zinc-800 dark:bg-white dark:text-zinc-900 dark:hover:bg-zinc-100";
  const secondaryBtnCls = "inline-flex items-center justify-center rounded-md bg-zinc-50 px-3 py-2 text-sm font-semibold text-zinc-900 ring-1 ring-inset ring-zinc-300 hover:bg-zinc-100 dark:bg-zinc-800 dark:text-zinc-100 dark:ring-white/10 dark:hover:bg-zinc-700";
  const formGroupCls = "mb-4";
  const cardCls = "mb-4 rounded-lg bg-zinc-50 shadow-sm ring-1 ring-zinc-200 dark:bg-zinc-900 dark:ring-zinc-700";
  const cardHeaderCls = "flex cursor-pointer flex-row items-center justify-between border-b border-zinc-200 px-4 py-3 dark:border-zinc-700";
  const cardBodyCls = "p-4";
  return (
    <div className="mx-auto w-full max-w-7xl px-0 py-4 sm:px-4 sm:py-6">
      <h1 className="text-2xl font-semibold tracking-tight text-zinc-900 dark:text-zinc-100">{eventRecapData?.sysname ? eventRecapData?.sysname : eventRecapData?.name}</h1>
      <div className="py-2"></div>
      <div className={cardCls}>
        <div className={cardHeaderCls} onClick={() => { updateShowModules('details', !showModules.details) }}>
          <h2>Event Recap Details</h2>
          <div>
            <span style={{ userSelect: 'none', WebkitUserSelect: 'none' }} className={showModules.details ? "pe-3 text-xs font-bold" : "pe-3 text-xs"}>Show</span>
            <span style={{ userSelect: 'none', WebkitUserSelect: 'none' }} className={!showModules.details ? "text-xs font-bold" : "text-xs"}>Hide</span>
          </div>
        </div>
        {showModules.details &&
          <div className={cardBodyCls}>
            <div className="flex flex-wrap gap-4">
              <div className="w-full">
                <div className="py-2"></div>
                <div className={manageSectionTitleCls}>Event</div>
                <div className="py-1"></div>
                <div className={formGroupCls}>
                  <label
                    className={labelCls}
                    onClick={() => {
                      setHelp({ ...help, sysname: !help.sysname });
                    }}
                  >
                    Event Name{" "}
                    <i className="xs">
                      <InfoIcon />
                    </i>
                  </label>
                  <div className={help.sysname ? "fs-xs" : "hidden"}>
                    Name for the event.
                  </div>
                  <input
                    type="text"
                    id="sysname"
                    name="sysname"
                    value={eventRecapData?.sysname || ''}
                    onChange={handleChange}
                    className={inputCls}
                    disabled={eventRecapData.allowPushToCap}
                  />
                </div>
                <div className={formGroupCls}>
                  <label className={labelCls}>Status</label>
                  <select
                    className={inputCls}
                    id="status"
                    name="status"
                    onChange={handleChange}
                    value={eventRecapData?.status}
                    disabled={eventRecapData.allowPushToCap}
                  >
                    <option value="Active">Active</option>
                    <option value="Archived">Archived</option>
                  </select>
                </div>

                <div className="flex flex-wrap gap-4">
                  <div className="flex-1 min-w-0">
                    <div className={formGroupCls}>
                      <label className={labelCls}>Start Date</label>
                      <input
                        type="date"
                        id="startDate"
                        name="startDate"
                        value={eventRecapData?.startDate || ''}
                        onChange={handleChange}
                        className={inputCls}
                        disabled={eventRecapData.allowPushToCap}
                      />
                    </div>
                  </div>
                  <div className="flex-1 min-w-0">
                    <div className={formGroupCls}>
                      <label className={labelCls}>End Date</label>
                      <input
                        type="date"
                        id="endDate"
                        name="endDate"
                        value={eventRecapData?.endDate || ''}
                        onChange={handleChange}
                        className={inputCls}
                        disabled={eventRecapData.allowPushToCap}
                      />
                    </div>
                  </div>
                </div>
                <div className={formGroupCls}>
                  <label
                    className={labelCls}
                    onClick={() => {
                      setHelp({ ...help, pcname: !help.pcname });
                    }}
                  >
                    Porsche Center Name{" "}
                    <i className="xs">
                      <InfoIcon />
                    </i>
                  </label>
                  <div className={help.pcname ? "fs-xs" : "hidden"}>
                    Name of the Porsche Center hosting the event.
                  </div>
                  <input
                    type="text"
                    id="pcname"
                    name="pcname"
                    value={eventRecapData?.pcname || ''}
                    onChange={handleChange}
                    className={inputCls}
                  // disabled={eventRecapData.allowPushToCap}
                  />
                </div>
                <div className={formGroupCls}>
                  <label
                    className={labelCls}
                    onClick={() => {
                      setHelp({ ...help, department: !help.department });
                    }}
                  >
                    Department{" "}
                    <i className="xs">
                      <InfoIcon />
                    </i>
                  </label>
                  <div className={help.department ? "fs-xs" : "hidden"}>
                    Department
                  </div>
                  <input
                    type="text"
                    id="department"
                    name="department"
                    value={eventRecapData?.department || ''}
                    onChange={handleChange}
                    className={inputCls}
                    disabled={eventRecapData.allowPushToCap}
                  />
                </div>
                <div className={formGroupCls}>
                  <label className={labelCls}>Event Type</label>
                  <select
                    className={inputCls}
                    id="eventType"
                    name="eventType"
                    onChange={handleChange}
                    value={eventRecapData?.eventType}
                  // disabled={eventRecapData.allowPushToCap}
                  >
                    <option value="">-- Select --</option>
                    <option value="launch">Launch</option>
                    <option value="nosub">There is no substitute</option>
                    <option value="driving">Driving</option>
                    <option value="place">PLACE</option>
                    <option value="performance">Performance</option>
                    <option value="crc">Classic Restoration Challenge</option>
                    <option value="motorsport">Motorsport (PCNA Hosted)</option>
                  </select>
                </div>
                <div className={formGroupCls}>
                  <label className={labelCls}>Event Format</label>
                  <select
                    className={inputCls}
                    id="eventFormat"
                    name="eventFormat"
                    onChange={handleChange}
                    value={eventRecapData?.eventFormat}
                  // disabled={eventRecapData.allowPushToCap}
                  >
                    <option value="">-- Select --</option>
                    <option value="national">National Event</option>
                    <option value="area">Area Event</option>
                    <option value="pc">Porsche Center Event</option>
                  </select>
                </div>
                <div className={formGroupCls}>
                  <label
                    className={labelCls}
                    onClick={() => {
                      setHelp({ ...help, eventReason: !help.eventReason });
                    }}
                  >
                    Event Reason{" "}
                    <i className="xs">
                      <InfoIcon />
                    </i>
                  </label>
                  <div className={help.eventReason ? "fs-xs" : "hidden"}>
                    Event Reason
                  </div>
                  <input
                    type="text"
                    id="eventReason"
                    name="eventReason"
                    value={eventRecapData?.eventReason || ''}
                    onChange={handleChange}
                    className={inputCls}
                  />
                </div>
                <div className={formGroupCls}>
                  <label
                    className={labelCls}
                    onClick={() => {
                      setHelp({ ...help, eventDescription: !help.eventDescription });
                    }}
                  >
                    Event Description{" "}
                    <i className="xs">
                      <InfoIcon />
                    </i>
                  </label>
                  <div className={help.eventDescription ? "fs-xs" : "hidden"}>
                    Event Description
                  </div>
                  <textarea
                    type="text"
                    id="eventDescription"
                    name="eventDescription"
                    value={eventRecapData?.eventDescription || ''}
                    onChange={handleChange}
                    className={inputCls}
                  />
                </div>
                <div className={formGroupCls}>
                  <label
                    className={labelCls}
                    onClick={() => {
                      setHelp({ ...help, eventBudget: !help.eventBudget });
                    }}
                  >
                    Event Budget{" "}
                    <i className="xs">
                      <InfoIcon />
                    </i>
                  </label>
                  <div className={help.eventBudget ? "fs-xs" : "hidden"}>
                    Event Budget
                  </div>
                  <input
                    type="number"
                    id="eventBudget"
                    name="eventBudget"
                    value={eventRecapData?.eventBudget || ''}
                    onChange={handleChange}
                    className={inputCls}
                    style={{ width: "100%" }}
                  />
                </div>
                <div className={formGroupCls}>
                  <label
                    className={labelCls}
                    onClick={() => {
                      setHelp({ ...help, eventSpend: !help.eventSpend });
                    }}
                  >
                    Event Spend{" "}
                    <i className="xs">
                      <InfoIcon />
                    </i>
                  </label>
                  <div className={help.eventSpend ? "fs-xs" : "hidden"}>
                    Event Spend
                  </div>
                  <input
                    type="number"
                    id="eventSpend"
                    name="eventSpend"
                    value={eventRecapData?.eventSpend || ''}
                    onChange={handleChange}
                    className={inputCls}
                    style={{ width: "100%" }}
                  />
                </div>
                <div className={formGroupCls}>
                  <label
                    className={labelCls}
                    onClick={() => {
                      setHelp({ ...help, eventSales: !help.eventSales });
                    }}
                  >
                    Event Sales{" "}
                    <i className="xs">
                      <InfoIcon />
                    </i>
                  </label>
                  <div className={help.eventSales ? "fs-xs" : "hidden"}>
                    Event Sales
                  </div>
                  <input
                    type="number"
                    id="eventSales"
                    name="eventSales"
                    value={eventRecapData?.eventSales || ''}
                    onChange={handleChange}
                    className={inputCls}
                    style={{ width: "100%" }}
                  />
                </div>

                <div className={formGroupCls}>
                  <label
                    className={labelCls}
                    onClick={() => {
                      setHelp({ ...help, eventLocation: !help.eventLocation });
                    }}
                  >
                    Event Location or Venue Name{" "}
                    <i className="xs">
                      <InfoIcon />
                    </i>
                  </label>
                  <div className={help.eventLocation ? "fs-xs" : "hidden"}>
                    Location of the event or venue name.
                  </div>
                  <input
                    type="text"
                    id="eventLocation"
                    name="eventLocation"
                    value={eventRecapData?.eventLocation || ''}
                    onChange={handleChange}
                    className={inputCls}
                  // disabled={eventRecapData.allowPushToCap}
                  />
                </div>
                <div className={formGroupCls}>
                  <label
                    className={labelCls}
                    onClick={() => {
                      setHelp({ ...help, eventCity: !help.eventCity });
                    }}
                  >
                    City{" "}
                    <i className="xs">
                      <InfoIcon />
                    </i>
                  </label>
                  <div className={help.eventCity ? "fs-xs" : "hidden"}>
                    City of the event or venue name.
                  </div>
                  <input
                    type="text"
                    id="eventCity"
                    name="eventCity"
                    value={eventRecapData?.eventCity || ''}
                    onChange={handleChange}
                    className={inputCls}
                  // disabled={eventRecapData.allowPushToCap}
                  />
                </div>
                <div className={formGroupCls}>
                  <label className={labelCls}>State</label>
                  <select
                    className={inputCls}
                    id="state"
                    name="state"
                    onChange={handleChange}
                    value={eventRecapData?.state}
                  // disabled={eventRecapData.allowPushToCap}
                  >
                    <option value="">-- Select --</option>
                    {StatesList.map((state) => <option value={state.abbreviation}>{state.name}</option>)}
                  </select>
                </div>
                <div className="py-2"></div>
                <div className={manageSectionTitleCls}>Contact</div>
                <div className={formGroupCls}>
                  <label
                    className={labelCls}
                    onClick={() => {
                      setHelp({ ...help, contactFirst: !help.contactFirst });
                    }}
                  >
                    Contact First Name{" "}
                    <i className="xs">
                      <InfoIcon />
                    </i>
                  </label>
                  <div className={help.contactFirst ? "fs-xs" : "hidden"}>
                    Contact First Name
                  </div>
                  <input
                    type="text"
                    id="contactFirst"
                    name="contactFirst"
                    value={eventRecapData?.contactFirst || ''}
                    onChange={handleChange}
                    className={inputCls}
                  />
                </div>
                <div className={formGroupCls}>
                  <label
                    className={labelCls}
                    onClick={() => {
                      setHelp({ ...help, contactLast: !help.contactLast });
                    }}
                  >
                    Contact Last Name{" "}
                    <i className="xs">
                      <InfoIcon />
                    </i>
                  </label>
                  <div className={help.contactLast ? "fs-xs" : "hidden"}>
                    Contact Last Name
                  </div>
                  <input
                    type="text"
                    id="contactLast"
                    name="contactLast"
                    value={eventRecapData?.contactLast || ''}
                    onChange={handleChange}
                    className={inputCls}
                  />
                </div>
                <div className={formGroupCls}>
                  <label
                    className={labelCls}
                    onClick={() => {
                      setHelp({ ...help, contactEmail: !help.contactEmail });
                    }}
                  >
                    Contact Email{" "}
                    <i className="xs">
                      <InfoIcon />
                    </i>
                  </label>
                  <div className={help.contactEmail ? "fs-xs" : "hidden"}>
                    Contact Email
                  </div>
                  <input
                    type="text"
                    id="contactEmail"
                    name="contactEmail"
                    value={eventRecapData?.contactEmail || ''}
                    onChange={handleChange}
                    className={inputCls}
                  />
                </div>
                <div className={formGroupCls}>
                  <label
                    className={labelCls}
                    onClick={() => {
                      setHelp({ ...help, contactPhone: !help.contactPhone });
                    }}
                  >
                    Contact Phone{" "}
                    <i className="xs">
                      <InfoIcon />
                    </i>
                  </label>
                  <div className={help.contactPhone ? "fs-xs" : "hidden"}>
                    Contact Phone
                  </div>
                  <input
                    type="text"
                    id="contactPhone"
                    name="contactPhone"
                    value={eventRecapData?.contactPhone || ''}
                    onChange={handleChange}
                    className={inputCls}
                  />
                </div>

                <div className="py-2"></div>
                <div className={manageSectionTitleCls}>Attendees</div>
                <div className="py-1"></div>
                <div className={formGroupCls}>
                  <label
                    className={labelCls}
                    onClick={() => {
                      setHelp({ ...help, attendance: !help.attendance });
                    }}
                  >
                    Attendance{" "}
                    <i className="xs">
                      <InfoIcon />
                    </i>
                  </label>
                  <div className={help.attendance ? "fs-xs" : "hidden"}>
                    Estimated number of attendees at the event.
                  </div>
                  <input
                    type="number"
                    id="attendance"
                    name="attendance"
                    value={eventRecapData?.attendance || ''}
                    onChange={handleChange}
                    className={inputCls}
                    style={{ width: "100%" }}
                  // disabled={eventRecapData.allowPushToCap}
                  />
                </div>

                <div className={formGroupCls}>
                  <label className={labelCls}>About Attendees</label>
                  <select
                    className={inputCls}
                    id="aboutattendees"
                    name="aboutattendees"
                    onChange={handleChange}
                    value={eventRecapData?.aboutattendees}
                  // disabled={eventRecapData.allowPushToCap}
                  >
                    <option value="">-- Select --</option>
                    <option value="current">Current Customers</option>
                    <option value="prospects">Prospects</option>
                    <option value="mix">Mix</option>
                  </select>
                </div>
                <div className={formGroupCls}>
                  <label className={labelCls}>Target Audience</label>
                  <select
                    className={inputCls}
                    id="targetaudience"
                    name="targetaudience"
                    onChange={handleChange}
                    value={eventRecapData?.targetaudience}
                  // disabled={eventRecapData.allowPushToCap}
                  >
                    <option value="">-- Select --</option>
                    <option value="women">Driven Women</option>
                    <option value="core">Driven Core</option>
                    <option value="youth">Driven Youth</option>
                    <option value="conquest">Conquest</option>
                  </select>
                </div>

                <div className="py-2"></div>
                <div className={manageSectionTitleCls}>Vehicles</div>
                <div className="py-1"></div>

                <div className={formGroupCls}>
                  <label className={labelCls}>Did you have vehicles at your event?</label>
                  <select
                    className={inputCls}
                    id="vehiclesatevent"
                    name="vehiclesatevent"
                    onChange={handleChange}
                    value={eventRecapData?.vehiclesatevent}
                  // disabled={eventRecapData.allowPushToCap}
                  >
                    <option value="">-- Select --</option>
                    <option value="yes">Yes</option>
                    <option value="no">No</option>
                  </select>
                </div>
                {eventRecapData?.vehiclesatevent === "yes" && (
                  <div className={formGroupCls}>
                    <label
                      className={labelCls}
                      onClick={() => {
                        setHelp({ ...help, vehiclecount: !help.vehiclecount });
                      }}
                    >
                      How many vehicles?{" "}
                      <i className="xs">
                        <InfoIcon />
                      </i>
                    </label>
                    <div className={help.vehiclecount ? "fs-xs" : "hidden"}>
                      How many vehicles were at the event?
                    </div>
                    <input
                      type="number"
                      id="vehiclecount"
                      name="vehiclecount"
                      value={eventRecapData?.vehiclecount || ''}
                      onChange={handleChange}
                      className={inputCls}
                    // disabled={eventRecapData.allowPushToCap}
                    />
                  </div>
                )}
                {eventRecapData?.vehiclesatevent === "yes" && (
                  <div className={formGroupCls}>
                    <label className={labelCls}>Which vehicles were highlighted at this event?</label>
                    <div>
                      {[
                        { value: "911", label: "911" },
                        { value: "718", label: "718" },
                        { value: "boxster", label: "Boxster" },
                        { value: "cayman", label: "Cayman" },
                        { value: "cayenne", label: "Cayenne" },
                        { value: "cayenne electric", label: "Cayenne Electric" },
                            { value: "macan", label: "Macan" },
                        { value: "macan electric", label: "Macan Electric" },
                        { value: "panamera", label: "Panamera" },
                        { value: "taycan", label: "Taycan" },
                      ].map((vehicle) => (
                        <div key={vehicle.value} className="mb-2 flex items-center gap-2">
                          <input
                            type="checkbox"
                            id={`vehicleshighlighted-${vehicle.value}`}
                            name="vehicleshighlighted"
                            value={vehicle.value}
                            checked={eventRecapData?.vehicleshighlighted?.includes(vehicle.value)}
                            onChange={(e) => {
                              const selectedVehicles = eventRecapData?.vehicleshighlighted || [];
                              if (e.target.checked) {
                                // Add the selected vehicle
                                setEventRecapData({
                                  ...eventRecapData,
                                  vehicleshighlighted: [...selectedVehicles, vehicle.value],
                                });
                              } else {
                                // Remove the unselected vehicle
                                setEventRecapData({
                                  ...eventRecapData,
                                  vehicleshighlighted: selectedVehicles.filter((v) => v !== vehicle.value),
                                });
                              }
                            }}
                            className="h-4 w-4 rounded border-zinc-300 text-zinc-900 focus:ring-zinc-900 dark:border-zinc-600 dark:bg-zinc-800 dark:focus:ring-white"
                          />
                          <label
                            htmlFor={`vehicleshighlighted-${vehicle.value}`}
                            className="text-sm text-zinc-700 dark:text-zinc-300"
                          >
                            {vehicle.label}
                          </label>
                        </div>
                      ))}
                    </div>
                  </div>
                )}
                {eventRecapData?.vehiclesatevent === "yes" && (
                  <>
                    <div className={formGroupCls}>
                      <label className={labelCls}>Did you have electric vehicles?</label>
                      <div>
                        {[
                          { value: "macan", label: "Macan" },
                          { value: "cayenne", label: "Cayenne" },
                          { value: "panamera", label: "Panamera" }
                        ].map((vehicle) => (
                          <div key={vehicle.value} className="mb-2 flex items-center gap-2">
                            <input
                              type="checkbox"
                              id={`electricmodels-${vehicle.value}`}
                              name="electricmodels"
                              value={vehicle.value}
                              checked={eventRecapData?.electricmodels?.includes(vehicle.value)}
                              onChange={(e) => {
                                const selectedVehicles = eventRecapData?.electricmodels || [];
                                if (e.target.checked) {
                                  // Add the selected vehicle
                                  setEventRecapData({
                                    ...eventRecapData,
                                    electricmodels: [...selectedVehicles, vehicle.value],
                                  });
                                } else {
                                  // Remove the unselected vehicle
                                  setEventRecapData({
                                    ...eventRecapData,
                                    electricmodels: selectedVehicles.filter((v) => v !== vehicle.value),
                                  });
                                }
                              }}
                              className="h-4 w-4 rounded border-zinc-300 text-zinc-900 focus:ring-zinc-900 dark:border-zinc-600 dark:bg-zinc-800 dark:focus:ring-white"
                            />
                            <label
                              htmlFor={`electricmodels-${vehicle.value}`}
                              className="text-sm text-zinc-700 dark:text-zinc-300"
                            >
                              {vehicle.label}
                            </label>
                          </div>
                        ))}
                      </div>
                    </div>
                  </>
                )}

                {eventRecapData?.electricmodels && (
                  <>
                    <div className={formGroupCls}>
                      <label className={labelCls}>Which specific trim levels?</label>
                      <select
                        className={inputCls}
                        id="vehicletrims"
                        name="vehicletrims"
                        onChange={handleChange}
                        value={eventRecapData?.vehicletrims}
                      // disabled={eventRecapData.allowPushToCap}
                      >
                        <option value="">-- Select --</option>
                        <option value="s">S</option>
                        <option value="t">T</option>
                        <option value="gts">GTS</option>
                        <option value="gt4">GT4</option>
                        <option value="gt3">GT3</option>
                        <option value="gt3rs">GT3 RS</option>
                        <option value="gt2">GT2</option>
                        <option value="turbo">Turbo</option>
                        <option value="turbos">Turbo S</option>
                        <option value="turbogt">Turbo GT</option>
                      </select>
                    </div>
                  </>
                )}
                {eventRecapData?.vehiclesatevent === "yes" && (
                  <div className={formGroupCls}>
                    <label className={labelCls}>Did your event include test drives?</label>
                    <select
                      className={inputCls}
                      id="testdrives"
                      name="testdrives"
                      onChange={handleChange}
                      value={eventRecapData?.testdrives}
                    // disabled={eventRecapData.allowPushToCap}
                    >
                      <option value="">-- Select --</option>
                      <option value="yes">Yes</option>
                      <option value="no">No</option>
                    </select>
                  </div>
                )}
                {eventRecapData?.testdrives === "yes" && (
                  <div className={formGroupCls}>
                    <label
                      className={labelCls}
                      onClick={() => {
                        setHelp({ ...help, testdrivecount: !help.testdrivecount });
                      }}
                    >
                      How many drives?{" "}
                      <i className="xs">
                        <InfoIcon />
                      </i>
                    </label>
                    <div className={help.testdrivecount ? "fs-xs" : "hidden"}>
                      How many test drives were conducted at the event?
                    </div>
                    <input
                      type="number"
                      id="testdrivecount"
                      name="testdrivecount"
                      value={eventRecapData?.testdrivecount || ''}
                      onChange={handleChange}
                      className={inputCls}
                      style={{ width: "100%" }}
                    // disabled={eventRecapData.allowPushToCap}
                    />
                  </div>
                )}

                <div className="py-2"></div>
                <div className={manageSectionTitleCls}>Catering</div>
                <div className="py-1"></div>
                <div className={formGroupCls}>
                  <label className={labelCls}>Was catering provided?</label>
                  <select
                    className={inputCls}
                    id="catering"
                    name="catering"
                    onChange={handleChange}
                    value={eventRecapData?.catering}
                  // disabled={eventRecapData.allowPushToCap}
                  >
                    <option value="">-- Select --</option>
                    <option value="yes">Yes</option>
                    <option value="no">No</option>
                  </select>
                </div>
                {eventRecapData?.catering === "yes" && (
                  <div className={formGroupCls}>
                    <label
                      className={labelCls}
                      onClick={() => {
                        setHelp({ ...help, cateringcompany: !help.cateringcompany });
                      }}
                    >
                      What was the name of the catering company?{" "}
                      <i className="xs">
                        <InfoIcon />
                      </i>
                    </label>
                    <div className={help.cateringcompany ? "fs-xs" : "hidden"}>
                      Name of the catering company that provided services for the event.
                    </div>
                    <input
                      type="text"
                      id="cateringcompany"
                      name="cateringcompany"
                      value={eventRecapData?.cateringcompany || ''}
                      onChange={handleChange}
                      className={inputCls}
                    // disabled={eventRecapData.allowPushToCap}
                    />
                  </div>
                )}
                {eventRecapData?.catering === "yes" && (
                  <div className={formGroupCls}>
                    <label
                      className={labelCls}
                      onClick={() => {
                        setHelp({ ...help, cateredproduct: !help.cateredproduct });
                      }}
                    >
                      What was catered?{" "}
                      <i className="xs">
                        <InfoIcon />
                      </i>
                    </label>
                    <div className={help.cateredproduct ? "fs-xs" : "hidden"}>
                      Description of the catered products or services provided at the event.
                    </div>
                    <input
                      type="text"
                      id="cateredproduct"
                      name="cateredproduct"
                      value={eventRecapData?.cateredproduct || ''}
                      onChange={handleChange}
                      className={inputCls}
                    // disabled={eventRecapData.allowPushToCap}
                    />
                  </div>
                )}
                <div className="py-2"></div>
                <div className={manageSectionTitleCls}>Partners</div>
                <div className="py-1"></div>
                <div className={formGroupCls}>
                  <label className={labelCls}>Did you partner with an organization?</label>
                  <select
                    className={inputCls}
                    id="partner"
                    name="partner"
                    onChange={handleChange}
                    value={eventRecapData?.partner}
                  // disabled={eventRecapData.allowPushToCap}
                  >
                    <option value="">-- Select --</option>
                    <option value="yes">Yes</option>
                    <option value="no">No</option>
                  </select>
                </div>
                {eventRecapData?.partner === "yes" && (
                  <div className={formGroupCls}>
                    <label
                      className={labelCls}
                      onClick={() => {
                        setHelp({ ...help, partnername: !help.partnername });
                      }}
                    >
                      Organization Name?{" "}
                      <i className="xs">
                        <InfoIcon />
                      </i>
                    </label>
                    <div className={help.partnername ? "fs-xs" : "hidden"}>
                      Name of the organization partnered with for the event.
                    </div>
                    <input
                      type="text"
                      id="partnername"
                      name="partnername"
                      value={eventRecapData?.partnername || ''}
                      onChange={handleChange}
                      className={inputCls}
                    // disabled={eventRecapData.allowPushToCap}
                    />
                  </div>
                )}
                <div className="py-2"></div>
                <div className={manageSectionTitleCls}>Giveaways</div>
                <div className="py-1"></div>
                <div className={formGroupCls}>
                  <label className={labelCls}>Did you have giveaways?</label>
                  <select
                    className={inputCls}
                    id="giveaways"
                    name="giveaways"
                    onChange={handleChange}
                    value={eventRecapData?.giveaways}
                  // disabled={eventRecapData.allowPushToCap}
                  >
                    <option value="">-- Select --</option>
                    <option value="yes">Yes</option>
                    <option value="no">No</option>
                  </select>
                </div>
                {eventRecapData?.giveaways === "yes" && (
                  <div className={formGroupCls}>
                    <label
                      className={labelCls}
                      onClick={() => {
                        setHelp({ ...help, giveawayitems: !help.giveawayitems });
                      }}
                    >
                      What items?{" "}
                      <i className="xs">
                        <InfoIcon />
                      </i>
                    </label>
                    <div className={help.giveawayitems ? "fs-xs" : "hidden"}>
                      Description of the giveaway items provided at the event.
                    </div>
                    <input
                      type="text"
                      id="giveawayitems"
                      name="giveawayitems"
                      value={eventRecapData?.giveawayitems || ''}
                      onChange={handleChange}
                      className={inputCls}
                    // disabled={eventRecapData.allowPushToCap}
                    />
                  </div>
                )}
              </div>
            </div>
          </div>
        }
      </div>

      <div className={cardCls}>
        <div className={cardHeaderCls} onClick={() => { updateShowModules('configuration', !showModules.configuration) }}>
          <h2>Attendees</h2>
          <div>
            <span style={{ userSelect: 'none', WebkitUserSelect: 'none' }} className={showModules.configuration ? "pe-3 text-xs font-bold" : "pe-3 text-xs"}>Show</span>
            <span style={{ userSelect: 'none', WebkitUserSelect: 'none' }} className={!showModules.configuration ? "text-xs font-bold" : "text-xs"}>Hide</span>
          </div>
        </div>
        {showModules.configuration &&
          <div className={cardBodyCls} style={{ position: "relative" }}>
            {!importReg && (
              <div className="flex-none">
                <div className="py-1"></div>
                <button
                  onClick={() => {
                    setImportReg(true);
                  }}
                  disabled={eventRecapData.allowPushToCap}
                  className={primaryBtnCls}
                >
                  Import List
                </button>
              </div>
            )}
            <div style={{ position: "absolute", right: "0", top: "0", padding: "16px" }}>
              <SwitchField checked={simpleViewAttendees} onChange={(checked) => {
                setSimpleViewAttendees(checked);
                localStorage.setItem('simpleViewAttendees', checked);
              }}>
                Compact View
              </SwitchField>
            </div>
            {importReg && (
              <>
                <div className={formGroupCls}>
                  <label className={labelCls}>Import List</label>
                  <div>
                    <input
                      id="originalFileName"
                      type="file"
                      name="originalFileName"
                      onChange={(e) => handleFileRead(e)}
                    />
                  </div>
                </div>
                <div>
                  <a href="/assets/import-template.csv">
                    Download Import Template
                  </a>
                </div>
                <div>
                  <button
                    type="button"
                    onClick={(e) => {
                      e.preventDefault();
                      setImportReg(false);
                    }}>
                    Cancel
                  </button>
                </div>
              </>
            )}
            <br /><br />
            {
              <div className="overflow-x-auto">
                <table className="min-w-full divide-y divide-zinc-200 text-sm dark:divide-zinc-700">
                  <thead className="bg-zinc-50 text-left text-xs font-semibold uppercase tracking-wide text-zinc-700 dark:bg-zinc-800 dark:text-zinc-300">
                    <tr>
                      {fieldList['company'] && !simpleViewAttendees &&
                        <th className="hidden px-3 py-2 md:table-cell">Company</th>
                      }
                      {fieldList['title'] && !simpleViewAttendees &&
                        <th className="hidden px-3 py-2 md:table-cell">Title</th>
                      }
                      {simpleViewAttendees &&
                        <th className="table-cell px-3 py-2">Name</th>
                      }
                      {fieldList['firstName'] && !simpleViewAttendees &&
                        <th className="table-cell px-3 py-2">First Name</th>
                      }
                      {fieldList['lastName'] && !simpleViewAttendees &&
                        <th className="table-cell px-3 py-2">Last Name</th>
                      }
                      {fieldList['email'] &&
                        <th className="table-cell px-3 py-2">Email</th>
                      }
                      {fieldList['phone'] &&
                        <th className="hidden px-3 py-2 md:table-cell">Phone</th>
                      }
                      {fieldList['address1'] && !simpleViewAttendees &&
                        <th className="hidden px-3 py-2 md:table-cell">Address 1</th>
                      }
                      {fieldList['address2'] && !simpleViewAttendees &&
                        <th className="hidden px-3 py-2 md:table-cell">Address 2</th>
                      }
                      {fieldList['city'] &&
                        <th className="hidden px-3 py-2 md:table-cell">City</th>
                      }
                      {fieldList['state'] &&
                        <th className="hidden px-3 py-2 md:table-cell">State</th>
                      }
                      {fieldList['postal'] && !simpleViewAttendees &&
                        <th className="hidden px-3 py-2 md:table-cell">Postal</th>
                      }
                      {fieldList['createdDate'] && !simpleViewAttendees &&
                        <th className="hidden px-3 py-2 md:table-cell">Created</th>
                      }
                      {fieldList['updatedDate'] && !simpleViewAttendees &&
                        <th className="hidden px-3 py-2 md:table-cell">Updated</th>
                      }
                      {fieldList['status'] &&
                        <th className="hidden px-3 py-2 md:table-cell">Status</th>
                      }
                      {eventRecapData?.allowGuests && fieldList['guest'] &&
                        <th className="hidden px-3 py-2 md:table-cell">Guest</th>
                      }
                      {fieldList['itemInfo'] &&
                        <th className="hidden px-3 py-2 md:table-cell">Item</th>
                      }
                      {fieldList['sessionInfo'] &&
                        <th className="hidden px-3 py-2 md:table-cell">Session</th>
                      }
                      {eventRecapData?.allowWaivers && fieldList['waiver'] &&
                        <th className="hidden px-3 py-2 md:table-cell">Waiver</th>
                      }
                      {eventRecapData?.allowGuestWaivers && fieldList['guestWaiver'] &&
                        <th className="hidden px-3 py-2 md:table-cell">Guest Waiver</th>
                      }
                      {/* <th className="hidden px-3 py-2 md:table-cell">Check-In</th> */}
                      {fieldList['passcode'] &&
                        <th className="hidden px-3 py-2 md:table-cell">Passcode</th>
                      }
                      {fieldList['dealer_optin'] &&
                        <th className="hidden px-3 py-2 md:table-cell">Dealer OptIn</th>
                      }
                      {fieldList['dealer'] &&
                        <th className="hidden px-3 py-2 md:table-cell">Pref Dealer</th>
                      }
                      {fieldList['experience'] &&
                        <th className="hidden px-3 py-2 md:table-cell">Experience</th>
                      }
                      {fieldList['modelInterest'] &&
                        <th className="hidden px-3 py-2 md:table-cell">Model Interest</th>
                      }
                      {fieldList['purchaseTimeFrame'] &&
                        <th className="hidden px-3 py-2 md:table-cell">Purchase Timeframe</th>
                      }
                      {fieldList['disableLead'] &&
                        <th className="hidden px-3 py-2 md:table-cell">Do Not Send C@P</th>
                      }
                      {fieldList['leadSent'] &&
                        <th className="hidden px-3 py-2 md:table-cell">Sent to C@P</th>
                      }
                      {eventRecapData?.additionalFields?.map((f, i) => (<>
                        <th key={i} className={fieldList[f.fieldName] ? "hidden px-3 py-2 md:table-cell" : "hidden"}>{f.fieldLabel}</th>
                        {f.fieldType === "CommerceItem" &&
                          <th key={100 + i} className={fieldList[f.fieldName + "Cost"] ? "hidden px-3 py-2 md:table-cell" : "hidden"}>{f.fieldLabel} Cost</th>
                        }
                      </>
                      ))}
                      {fieldList['notes'] &&
                        <th className="hidden px-3 py-2 md:table-cell">Notes</th>
                      }
                      <th className="hidden px-3 py-2 text-center md:table-cell">Delete</th>
                    </tr>
                  </thead>
                  <tbody>
                    {registrationData?.registrations?.map((r, i) => (
                      <tr
                        key={i}
                        className={alertRules(r) + "test my-2 pointer"}
                      >
                        {fieldList['company'] && !simpleViewAttendees &&
                          <td

                            className="hidden px-3 py-2 md:table-cell"
                          >
                            {r.company}
                          </td>
                        }
                        {fieldList['title'] && !simpleViewAttendees &&
                          <td

                            className="hidden px-3 py-2 md:table-cell"
                          >
                            {r.title}
                          </td>
                        }
                        {simpleViewAttendees &&
                          <td

                            className="table-cell px-3 py-2"
                          >
                            {r.firstName} {r.lastName}
                          </td>
                        }
                        {fieldList['firstName'] && !simpleViewAttendees &&
                          <td

                            className="table-cell px-3 py-2"
                          >
                            {r.firstName}
                          </td>
                        }
                        {fieldList['lastName'] && !simpleViewAttendees &&
                          <td

                            className="table-cell px-3 py-2"
                          >
                            {r.lastName}
                          </td>
                        }
                        {fieldList['email'] &&
                          <td

                            className="table-cell px-3 py-2"
                          >
                            {r.email}
                          </td>
                        }
                        {fieldList['phone'] &&
                          <td

                            className="hidden px-3 py-2 md:table-cell"
                          >
                            {r.phone}
                          </td>
                        }
                        {fieldList['address1'] && !simpleViewAttendees &&
                          <td

                            className="hidden px-3 py-2 md:table-cell"
                          >
                            {r.address1}
                          </td>
                        }
                        {fieldList['address2'] && !simpleViewAttendees &&
                          <td

                            className="hidden px-3 py-2 md:table-cell"
                          >
                            {r.address2}
                          </td>
                        }
                        {fieldList['city'] &&
                          <td

                            className="hidden px-3 py-2 md:table-cell"
                          >
                            {r.city}
                          </td>
                        }
                        {fieldList['state'] &&
                          <td

                            className="hidden px-3 py-2 md:table-cell"
                          >
                            {r.state}
                          </td>
                        }
                        {fieldList['postal'] && !simpleViewAttendees &&
                          <td

                            className="hidden px-3 py-2 md:table-cell"
                          >
                            {r.postal}
                          </td>
                        }
                        {fieldList['createdDate'] && !simpleViewAttendees &&
                          <td

                            className="hidden px-3 py-2 md:table-cell"
                          >
                            {r.createdDate}
                          </td>
                        }
                        {fieldList['updatedDate'] && !simpleViewAttendees &&
                          <td

                            className="hidden px-3 py-2 md:table-cell"
                          >
                            {r.updatedDate}
                          </td>
                        }
                        {fieldList['status'] && !simpleViewAttendees &&
                          <td

                            className="hidden px-3 py-2 md:table-cell"
                          >
                            {getRegistrationStatusLabel(r)}
                          </td>
                        }
                        {r.guestId && eventRecapData?.allowGuests && fieldList['guest'] && (
                          <td
                            className="hidden px-3 py-2 md:table-cell"
                          >
                            View Guest
                          </td>
                        )}
                        {r.parentId && eventRecapData?.allowGuests && fieldList['guest'] && (
                          <td
                            className="hidden px-3 py-2 md:table-cell"
                          >
                            View Primary
                          </td>
                        )}
                        {!r.parentId && !r.guestId && eventRecapData?.allowGuests && fieldList['guest'] && (
                          <td

                          >
                            {r.guestFirstName || r.guestLastName ? r.guestFirstName + " " + r.guestLastName : "--"}
                          </td>
                        )}
                        {fieldList['itemInfo'] &&
                          <td

                            className="hidden px-3 py-2 md:table-cell"
                          >
                            {r.sessionItemId !== null && r.sessionItemId !== undefined && +r.sessionItemId >= 0 ? eventRecapData?.sessionItems[+r.sessionItemId].name : ""}
                          </td>
                        }
                        {fieldList['sessionInfo'] &&
                          <td

                            className="hidden px-3 py-2 md:table-cell"
                          >
                            {r.sessionDate} {r.sessionTime}
                          </td>
                        }
                        {eventRecapData?.allowWaivers && fieldList['waiver'] &&
                          <td

                            className="hidden px-3 py-2 md:table-cell"
                          >
                            {r.hasWaiver
                              ? "Complete"
                              : eventRecapData?.allowWaivers
                                ? "Incomplete"
                                : "N/A"}
                          </td>
                        }
                        {eventRecapData?.allowGuestWaivers && fieldList['guestWaiver'] &&
                          <td

                            className="hidden px-3 py-2 md:table-cell"
                          >
                            {r.hasGuestWaiver
                              ? "Complete"
                              : eventRecapData?.allowGuestWaivers && (r.guestFirstName || r.guestLastName)
                                ? "Incomplete"
                                : "N/A"}
                          </td>
                        }
                        {/* <td className="hidden px-3 py-2 md:table-cell">
                          {r.status === "Registered" &&
                            (r.hasWaiver || !eventRecapData?.allowWaivers) && (r.hasGuestWaiver || !eventRecapData?.allowGuestWaivers || (!r.guestFirstName && !r.guestLastName)) && (
                              <i
                                className="sm"
                                // onClick={(e) => {
                                //   e.preventDefault();
                                //   e.stopPropagation();
                                //   let tmpRegs = registrationData.registrations;
                                //   tmpRegs[r.idx].status  = "Checked-In";
                                //   // db.collection("registrations")
                                //   //   .doc(tmpRegs[r.idx].id)
                                //   //   .set(tmpRegs[r.idx]);
                                //   setRegistrationData({
                                //     ...registrationData,
                                //     registrations: tmpRegs,
                                //     filter: true,
                                //   });
                                // }}
                              >
                                <CheckIcon />
                              </i>
                            )}
                        </td> */}
                        {fieldList['passcode'] &&
                          <td

                            className="hidden px-3 py-2 md:table-cell"
                          >
                            {r.passcode} {getPasscodeDescription(r.passcode)}
                          </td>
                        }
                        {fieldList['dealer_optin'] &&
                          <td

                            className="hidden px-3 py-2 md:table-cell"
                          >
                            {r.dealer_optin ? "Yes" : "No"}
                          </td>
                        }
                        {fieldList['dealer'] &&
                          <td

                            className="hidden px-3 py-2 md:table-cell"
                          >
                            {dealers.find((d) => d.code === r.dealer)?.name} {r.dealer && r.dealer !== "--" ? "(" + r.dealer + ")" : ""}
                          </td>
                        }
                        {fieldList['experience'] &&
                          <td

                            className="hidden px-3 py-2 md:table-cell"
                          >
                            {getExperience(r.experience)}
                          </td>
                        }
                        {fieldList['modelInterest'] &&
                          <td

                            className="hidden px-3 py-2 md:table-cell"
                          >
                            {getModelInterest(r.modelInterest)}
                          </td>
                        }
                        {fieldList['purchaseTimeFrame'] &&
                          <td
                            className="hidden px-3 py-2 md:table-cell"
                          >
                            {getPurchaseTimeFrame(r.purchaseTimeFrame)}
                          </td>
                        }
                        {fieldList['disableLead'] &&
                          <td
                            className="hidden px-3 py-2 md:table-cell"
                          >
                            {r.disableLead ? "Yes" : "No"}
                          </td>
                        }
                        {fieldList['leadSent'] &&
                          <td
                            className="hidden px-3 py-2 md:table-cell"
                          >
                            {r.leadSent ? "Yes" : "No"}
                          </td>
                        }
                        {eventRecapData?.additionalFields?.map((f, i) => (
                          <>
                            <td key={i}
                              className={fieldList[f.fieldName] ? "hidden px-3 py-2 md:table-cell" : "hidden"}
                            >
                              {f.fieldType === "Checkbox" ? r[f.fieldName] ? "Yes" : "No" : r[f.fieldName]}
                            </td>
                            {f.fieldType === "CommerceItem" &&
                              <td key={i + 100}
                                className={fieldList[f.fieldName + "Cost"] ? "hidden px-3 py-2 md:table-cell" : "hidden"}
                              >
                                {r[f.fieldName + "Cost"]}
                              </td>
                            }
                          </>
                        ))}
                        {fieldList['notes'] &&
                          <td
                            className="hidden px-3 py-2 md:table-cell"
                          >
                            {r.notes}
                          </td>
                        }
                        <td align="center">
                          <IconButton
                            label="Delete registration"
                            icon={TrashIcon}
                            className="text-red-600 hover:text-red-700 dark:text-red-500 dark:hover:text-red-400"
                            onClick={() => {
                              const updatedRegistrations = registrationData.registrations.filter(
                                (reg, index) => index !== i // Remove the record at the current index
                              );
                              // setRegistrationData({
                              //   ...registrationData,
                              //   registrations: updatedRegistrations,
                              // });
                              setEventRecapData({
                                ...eventRecapData,
                                registrations: updatedRegistrations,
                              });
                              setRegistrationData({
                                ...registrationData,
                                registrations: updatedRegistrations,
                              });
                              toast.success("Registration record deleted successfully.");
                            }}
                          />
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            }
          </div>
        }
      </div>


      {/* <div className={!eventRecapData?.disableRegistration ? "card mb-4" : "d-none"}>
        <div className={cardHeaderCls} onClick={() => { updateShowModules('leads', !showModules.leads) }}>
          <h2>C@P Lead Processing</h2>
          <div>
            <span style={{ userSelect: 'none', WebkitUserSelect: 'none' }} className={showModules.leads ? "active pe-3" : "pe-3"}>Show</span>
            <span style={{ userSelect: 'none', WebkitUserSelect: 'none' }} className={!showModules.leads ? "active" : ""}>Hide</span>
          </div>
        </div>
        {showModules.leads &&
          <div className={cardBodyCls}>
            <div className={formGroupCls}>
              <label className="checkbox-container">
                Send Event Data to C@P
                <input
                  type="checkbox"
                  onChange={(e) => {
                    // if (user.email.indexOf("core12.com") > -1) {
                    if (e.target.checked) {
                      const confirmAction = window.confirm(
                        "Once this checkbox is enabled, you will be unable to make changes to the event recap attendee list, name, start & end dates, and status. Do you want to continue?"
                      );
                      if (confirmAction) {
                        setEventRecapData({
                          ...eventRecapData,
                          allowPushToCap: true,
                        });
                      } else {
                        e.target.checked = false; // Reset the checkbox
                      }
                    } else {
                      if (user.role > 1) {
                        alert('Contact an Admin to disable this feature');
                      } else {
                        setEventRecapData({
                          ...eventRecapData,
                          allowPushToCap: false,
                        });
                      }
                    }
                  }}
                  id="allowPushToCap"
                  name="allowPushToCap"
                  checked={eventRecapData?.allowPushToCap || false}
                />
                <span className="checkmark"></span>
              </label>
            </div>
            {eventRecapData?.allowPushToCap &&
              <>
                {!eventRecapData?.campaignCode &&
                  <div>
                    <Multiselect
                      options={campaignCodes}
                      style={multiSelectStyle}
                      displayValue="label"
                      closeIcon="close"
                      selectionLimit={1}
                      onSelect={(selectedList, selectedItem) => {
                        console.log(selectedItem);
                        setEventRecapData({
                          ...eventRecapData,
                          campaignCode: selectedItem.value.leadCampaignCode,
                          campaignDescription: selectedItem.value.leadCampaignDescription,
                          campaignAltCode: selectedItem.value.ihCampaignCode,
                          campaignAltDescription: selectedItem.value.ihCampaignDescription
                        });
                      }}
                    />
                  </div>
                }
                <div className={formGroupCls}>
                  <label className={labelCls}>Campaign Code</label>
                  <input
                    disabled={eventRecapData?.campaignCodeVerified || user.role > 1}
                    type="text"
                    id="campaignCode"
                    name="campaignCode"
                    value={eventRecapData?.campaignCode || ''}
                    onChange={handleChange}
                    className={inputCls}
                  />
                </div>
                <div className={formGroupCls}>
                  <label className={labelCls}>Campaign Description</label>
                  <input
                    disabled={eventRecapData?.campaignCodeVerified || user.role > 1}
                    type="text"
                    id="campaignDescription"
                    name="campaignDescription"
                    value={eventRecapData?.campaignDescription || ''}
                    onChange={handleChange}
                    className={inputCls}
                  />
                </div>
                <div className={formGroupCls}>
                  <label className={labelCls}>Campaign Interaction History Code</label>
                  <input
                    disabled={eventRecapData?.campaignCodeVerified || user.role > 1}
                    type="text"
                    id="campaignAltCode"
                    name="campaignAltCode"
                    value={eventRecapData?.campaignAltCode || ''}
                    onChange={handleChange}
                    className={inputCls}
                  />
                </div>
                <div className={formGroupCls}>
                  <label className={labelCls}>Campaign Interaction History Description</label>
                  <input
                    disabled={eventRecapData?.campaignCodeVerified || user.role > 1}
                    type="text"
                    id="campaignAltDescription"
                    name="campaignAltDescription"
                    value={eventRecapData?.campaignAltDescription || ''}
                    onChange={handleChange}
                    className={inputCls}
                  />
                </div>
                <div className={formGroupCls}>
                  <label className={labelCls}>Campaign Comments</label>
                  <input
                    disabled={eventRecapData?.campaignCodeVerified || user.role > 1}
                    type="text"
                    id="campaignComments"
                    name="campaignComments"
                    value={eventRecapData?.campaignComments || ''}
                    onChange={handleChange}
                    className={inputCls}
                  />
                </div>
                <div
                  className=
                  "row align-items-center"
                >
                  <div className="flex-1 min-w-0">
                    <div className={formGroupCls}>
                      <label className="checkbox-container">
                        Approved by Stakeholder & CRM
                        <input
                          type="checkbox"
                          onChange={(e) => {
                            if (user.email.indexOf("core12.com") > -1) {
                              setEventRecapData({
                                ...eventRecapData,
                                campaignCodeVerified: e.target.checked,
                              });
                            } else {
                              alert('Contact a Core12 Admin to enable this feature');
                            }
                          }}
                          id="campaignCodeVerified"
                          name="campaignCodeVerified"
                          checked={eventRecapData?.campaignCodeVerified || false}
                        />
                        <span className="checkmark"></span>
                      </label>
                    </div>
                  </div>
                </div>
              </>
            }
          </div>
        }
      </div> */}
      <div className={cardCls}>
        <div className={cardHeaderCls} onClick={() => { updateShowModules('gallery', !showModules.gallery) }}>
          <h2>Media</h2>
          <div>
            <span style={{ userSelect: 'none', WebkitUserSelect: 'none' }} className={showModules.gallery ? "pe-3 text-xs font-bold" : "pe-3 text-xs"}>Show</span>
            <span style={{ userSelect: 'none', WebkitUserSelect: 'none' }} className={!showModules.gallery ? "text-xs font-bold" : "text-xs"}>Hide</span>
          </div>
        </div>
        {showModules.gallery &&
          <div className={cardBodyCls}>
            <div className="flex flex-wrap gap-4">
              <div className="w-full">
                <div className="flex flex-wrap gap-4" style={{ width: "100%", display: "flex", justifyContent: "center" }}>

                  {/*  EXTERNAL GALLERY LINK */}
                  <div className={formGroupCls}>
                    <label
                      className={labelCls}
                      onClick={() => {
                        setHelp({ ...help, externalgallery: !help.externalgallery });
                      }}
                    >
                      Enter External Gallery Link{" "}
                      <i className="xs">
                        <InfoIcon />
                      </i>
                    </label>
                    <div className={help.externalgallery ? "fs-xs" : "hidden"}>
                      Link to the external gallery for the event.
                    </div>
                    <input
                      type="url"
                      id="externalgallery"
                      name="externalgallery"
                      value={eventRecapData?.externalgallery || ''}
                      onChange={handleChange}
                      className={inputCls}
                      placeholder="https://example.com"
                      pattern="https://.*"
                    // disabled={eventRecapData.allowPushToCap}
                    />
                  </div>
                  <div className={formGroupCls}>
                    <label
                      className={labelCls}
                      onClick={() => {
                        setHelp({ ...help, videoLink: !help.videoLink });
                      }}
                    >
                      Enter Video Link{" "}
                      <i className="xs">
                        <InfoIcon />
                      </i>
                    </label>
                    <div className={help.videoLink ? "fs-xs" : "hidden"}>
                      Link to the video for the event.
                    </div>
                    <input
                      type="url"
                      id="videoLink"
                      name="videoLink"
                      value={eventRecapData?.videoLink || ''}
                      onChange={handleChange}
                      className={inputCls}
                      placeholder="https://example.com"
                      pattern="https://.*"
                    // disabled={eventRecapData.allowPushToCap}
                    />
                  </div>
                </div>
                <div className={formGroupCls}>
                  <label
                    className={labelCls}
                    onClick={() => {
                      setHelp({ ...help, internalgallery: !help.internalgallery });
                    }}
                  >
                    Upload Gallery Photos{" "}
                  </label>
                  <ImageDropper images={eventRecapData?.tmpProblemFiles} file_details={true}
                    editorOnProcess={async (pendingFiles) => {
                      let tmpProblemFiles = { ...eventRecapData?.problem_files };
                      tmpProblemFiles.pendingUploads = pendingFiles.length;
                      setEventRecapData({ ...eventRecapData, problem_files: tmpProblemFiles });
                    }}
                    editorOnUpload={async (pendingFiles) => {
                      let tmpProblemFiles = { ...eventRecapData?.problem_files };
                      let problemFiles = tmpProblemFiles.files || [];


                      // const supabase = await CreateClient(session);
                      let index = eventRecapData?.galleryImages?.length || 0;
                      let tmpEventRecapData = { ...eventRecapData };
                      for (let file of pendingFiles) {
                        let fileExtension = file.type.includes('image') ? 'jpg' : file.name.split('.').pop();
                        let filename = `problem_file${new Date().getTime()}.${fileExtension}`;
                        let fileMeta = { filename: filename, caption: file.caption || "", filetype: file.type, size: file.size }


                        tmpEventRecapData = await handleGalleryImageRead(file, index++, "append", fileMeta, tmpEventRecapData);
                        problemFiles.push(fileMeta);
                      };

                      tmpProblemFiles.files = problemFiles || [];
                      tmpProblemFiles.allowUpload = false;
                      tmpProblemFiles.pendingUploads = 0;
                      setEventRecapData({ ...eventRecapData, problem_files: tmpProblemFiles, galleryImages: tmpEventRecapData?.galleryImages || [] });

                      // UPDATE EVENT RECAP DATA IN DB
                      // handleSubmit(); // temporary until we have a better way to handle this

                      // const { data, error } = await supabase.from("ci_events").update(tmpCIEvent).eq("id", ciEvent.id);
                      // if (error) {
                      //   console.error('Error updating CI Event:', error);
                      //   toast.alert('Error updating CI Event: ' + error.message, 'alert-error');
                      //   return false;
                      // }

                      toast.success('Files saved successfully', 'alert-success');
                      return true;
                      // }
                    }}

                  />
                </div>
                <>
                  <div className="py-2"></div>
                  <div className="flex flex-wrap gap-4" style={{ rowGap: "20px" }}>
                    {eventRecapData?.galleryImages?.map((img, index) => {
                      return (
                        <div key={index} className="responsive-gallery-wrapper w-full" style={{ display: "flex" }}>
                          <div className="gallery-image-container w-full lg:w-1/4">
                            <div className={formGroupCls}>
                              <div>
                                <input
                                  id={"originalFileName" + index}
                                  type="file"
                                  name="originalFileName"
                                  style={{ width: "100%" }}
                                  onChange={(e) => {
                                    if (!e.target.files || e.target.files.length === 0) return;
                                    handleGalleryImageRead(e.target.files[0], index, "replace", {}, eventRecapData)
                                  }}
                                />
                              </div>
                            </div>
                            <div className={img ? "" : "hidden"}>
                              <img alt="" id={"galleryImage" + index}
                                className="gallery-image w-full md:w-1/2"
                                src={img.preview}
                              />
                            </div>
                            <div className="text-right">
                              <i className="del-icon ml-2" onClick={(e) => {
                                removeCloudinary("pcna/ezentrum/" + eventRecapData?.id + "/" + eventRecapData?.id + "_galleryImage_" + index, null);
                                let galleryImages = eventRecapData?.galleryImages;
                                galleryImages.splice(index, 1);
                                setEventRecapData({ ...eventRecapData, galleryImages: galleryImages });
                              }}>
                                <DeleteIcon />
                              </i>
                            </div>
                          </div>
                          <div className="w-full lg:w-2/3" style={{ display: "flex", flexDirection: "row", flexWrap: "wrap", gap: "10px", alignContent: "flex-start" }}>
                            {Array.isArray(img?.caption) && img.caption.map((caption, captionIndex) => (
                              <div>
                                <DismissibleTag
                                  key={captionIndex}
                                  onClick={() => {
                                    let tmpGalleryImages = [...eventRecapData?.galleryImages];
                                    tmpGalleryImages[index].caption.splice(captionIndex, 1);
                                    setEventRecapData({ ...eventRecapData, galleryImages: tmpGalleryImages || [] });
                                    toast.success('Caption removed successfully.', 'alert-success');
                                  }}
                                >
                                  {caption}
                                </DismissibleTag>
                              </div>
                            ))}
                            <form className="flex w-full min-w-0 items-center gap-2 sm:min-w-[220px] sm:w-auto" onSubmit={(e) => addCaption(e, index)}>
                              <input
                                type="text"
                                name="captionInput"
                                className={`${inputCls} !mt-0`}
                                value={eventRecapData?.galleryImages[index]?.captionInput}
                                placeholder="Add Tag"
                                onChange={(e) => {
                                  let tmpEventRecapData = { ...eventRecapData };
                                  tmpEventRecapData.galleryImages[index].captionInput = e.target.value;
                                  setEventRecapData(tmpEventRecapData || []);
                                }}
                              />
                              <button type="submit" className={secondaryBtnCls}>
                                Add
                              </button>
                            </form>
                          </div>
                          <div className="w-full lg:w-1/12" style={{ display: "flex", flexDirection: "row", height: "min-content", alignItems: "center", justifyContent: "center", gap: "10px" }}>
                            <IconButton label="Move image up" icon={ArrowUpIcon} style={{ visibility: index == 0 ? 'hidden' : 'visible' }} onClick={() => {
                              if (index > 0) {
                                const tmpGalleryImages = [...eventRecapData.galleryImages];
                                // Swap the current image with the one above
                                [tmpGalleryImages[index - 1], tmpGalleryImages[index]] = [tmpGalleryImages[index], tmpGalleryImages[index - 1]];
                                setEventRecapData({ ...eventRecapData, galleryImages: tmpGalleryImages });
                              }
                            }} />
                            <IconButton label="Move image down" icon={ArrowDownIcon} style={{ visibility: index == eventRecapData?.galleryImages.length - 1 ? 'hidden' : 'visible' }} onClick={() => {
                              if (index < eventRecapData.galleryImages.length - 1) {
                                const tmpGalleryImages = [...eventRecapData.galleryImages];
                                // Swap the current image with the one below
                                [tmpGalleryImages[index + 1], tmpGalleryImages[index]] = [tmpGalleryImages[index], tmpGalleryImages[index + 1]];
                                setEventRecapData({ ...eventRecapData, galleryImages: tmpGalleryImages });
                              }
                            }} />
                          </div>
                        </div>
                      )
                    })}
                  </div>
                </>
              </div>
            </div>
          </div>
        }
      </div>
      <div className="flex flex-wrap gap-4">
        <div className="w-full">
          <div className={cardCls}>
            <div className={cardHeaderCls}>
              <h2>Event History</h2>
            </div>
            <div className={cardBodyCls}>
              <div><label>Created:</label>{eventRecapData?.createdAt ? moment(eventRecapData?.createdAt).format("MM/DD/YYYY h:mm A") : "N/A"}</div>
              <div><label>Updated:</label> {eventRecapData?.updatedAt ? moment(eventRecapData?.updatedAt).format("MM/DD/YYYY h:mm A") : "N/A"}</div>
            </div>
          </div>
        </div>
      </div>
      <div className="py-3"></div>
      <div className={floatingSave ? "floating-save" : "pb-4"}>
        <div className="flex flex-wrap gap-4">
          <div className="flex-none">
            <button className={primaryBtnCls} onClick={handleSubmit}>
              Save
            </button>
          </div>
          <div className="flex-none">
            <button onClick={() => {
              setCurrentEventRecapData({});
              sessionStorage.removeItem('eventRecapData');
              setEventRecapData({});
              setTimeout(() => {
                window.location.href = "/manage/event-recaps";
              }, 20)
            }}
              className={secondaryBtnCls}>Close</button>
          </div>
          <div className="flex-1 min-w-0 text-right">
          </div>
        </div>
      </div>
      <div className="py-3"></div>
      <div className="py-3"></div>
      <VisualEditorModal
        changeItem={handleChangeItem}
        fieldList={fieldList}
        idkey={editCopy}
        onClose={() => setEditCopy(null)}
        value={eventRecapData}
      />
      {eventRecapData?.id && (
        <div className="record-id-badge pointer-events-none fixed bottom-2 left-2 z-10 select-text">
          <div className="pointer-events-auto truncate rounded-md bg-zinc-50/90 px-2 py-1 text-xs text-zinc-600 shadow-sm ring-1 ring-zinc-200 backdrop-blur dark:bg-zinc-900/90 dark:text-zinc-400 dark:ring-zinc-700">
            Id: {eventRecapData?.id}
          </div>
        </div>
      )}
    </div>
  );
};
export default EventRecap;
